<form #newA="ngForm" name="newA" (ngSubmit)="onSubmit(newA)" id="newA" class="course-form mb-0">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-clipboard-list" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">{{isEdit ? 'Edit Assessment' : 'Create New Assessment'}}</h1>
      <p class="cf-head__sub">Set the questions type, timing and weighting</p>
    </div>
    <div class="cf-head__actions">
      <button type="button" class="btn btn--warning m-0" *ngIf="isEdit" routerLink="/user/assessmentdetails"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID,aid:this.assessmentItem.id}">Cancel</button>
      <button type="button" class="btn btn--warning m-0" routerLink="/user/assessmentconsole"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID}" *ngIf="!isEdit">Cancel</button>
      <button type="submit" class="btn m-0" [disabled]="!newA.valid || freezePage_formSubmissionInProgress">
        <i class="fas fa-save" aria-hidden="true"></i> Save Assessment
      </button>
    </div>
  </header>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-file-alt" aria-hidden="true"></i> Basic Information</h2>
  <div class="fieldset fieldset--lg">
    <label for="name" class="legend">Name <span class="requiredfield">*</span></label>
    <input class="text-field" required type="text" id="name" name="name" [(ngModel)]="this.assessmentItem.name" #name
      autofocus>
  </div>
  <!-- Was a flex row with its own `fieldset--lg m-auto`, which centred the pair at a width
       unrelated to the card and left it out of line with the fields above and below. -->
  <div class="cf-grid">
    <div class="fieldset fieldset--lg" *ngIf="!isEdit">
      <label for="adm" class="legend">Assessment Type <span class="requiredfield">*</span></label>
      <select class="text-field" ngModel name="deliveryMode" id="adm" #deliveryMode required>
        <option value="{{AssessmentDeliveryMode_UntimedAssessment}}">Untimed Assessment</option>
        <option value="{{AssessmentDeliveryMode_TimedAssessment}}">Timed Assessment</option>
      </select>
    </div>
    <div class="fieldset fieldset--lg" id="durationHolder"
      *ngIf="assessmentItem.timedType!='UntimedAssessment'">
      <label for="duration" class="legend">Duration (Minutes)</label>
      <input class="text-field" type="number" id="duration" name="duration" [(ngModel)]="this.assessmentItem.duration"
        #duration>
    </div>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="!isEdit">
    <label for="assessmentType" class="legend">Question Type <span class="requiredfield">*</span></label>
    <select class="text-field" ngModel name="assessmentType" id="assessmentType" #assessmentType [(ngModel)]="this.assessmentItem.questionType" required>
      <option value="{{QuestionType_MultipleChoice}}">Multiple Choice</option>
      <option value="{{QuestionType_LongText}}">Essay/Comprehension</option>
      <option value="{{QuestionType_FileUpload}}">File Upload</option>
    </select>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="this.assessmentItem.questionType === QuestionType_LongText">
    <label for="essayTextLimit" class="legend">Maximum Word Count</label>
    <input class="text-field" type="number" id="essayTextLimit" name="essayTextLimit" [(ngModel)]="this.assessmentItem.essayTextLimit" #essayTextLimit
    >
  </div>
  </section>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-calendar-alt" aria-hidden="true"></i> Availability</h2>
    <div class="cf-grid">
  <div class="fieldset fieldset--lg">
    <label for="startt" class="legend">Start Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawStartTime" class="text-field" id="startt" name="startt"
      [(ngModel)]="this.assessmentItem.rawStartTime" #startt [disabled]="isMultipleBatch">
    <button [owlDateTimeTrigger]="rawStartTime" type="button" [disabled]="isMultipleBatch"
      class="owlDateTimeTrigger position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      [ngClass]="isMultipleBatch? 'bottom-0-t':'bottom-0'" title="Calendar"><i class="fa fa-calendar"></i></button>
    <owl-date-time #rawStartTime></owl-date-time>

    <p class="form-info-p" *ngIf="isMultipleBatch">Please update the assessment start and end times from the currently
      running batches after save. <a [routerLink]="['/user/modulebatches']" [queryParams]="{moduleID: moduleId}">View Batches</a>
    </p>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="endt" class="legend">Due Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawEndTime" class="text-field" id="endt" name="endt"
      [(ngModel)]="this.assessmentItem.rawEndTime" #endt [disabled]="isMultipleBatch">
    <button [owlDateTimeTrigger]="rawEndTime" type="button" [disabled]="isMultipleBatch"
      class="owlDateTimeTrigger position-absolute right-0 top-0  m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      [ngClass]="isMultipleBatch? 'bottom-0-t':'bottom-0'" title="Calendar"><i class="fa fa-calendar"></i></button>
    <owl-date-time #rawEndTime></owl-date-time>

    <p class="form-info-p" *ngIf="isMultipleBatch">Please update the assessment start and end times from the currently
      running batches after save. <a [routerLink]="['/user/modulebatches']" [queryParams]="{moduleID: moduleId}">View Batches</a>
    </p>
  </div>
    </div>
  </section>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="fas fa-sliders-h" aria-hidden="true"></i> Scoring &amp; Behaviour</h2>
    <div class="cf-grid">
  <div class="fieldset fieldset--lg">
    <label for="optional" class="legend">Optional</label>
    <!-- These were plain `value` attributes, so the option values were the strings "true"/"false"
         while the model holds a boolean. Nothing ever matched and the control rendered blank on a
         new assessment. [ngValue] binds the real boolean. -->
    <select class="text-field" [(ngModel)]="this.assessmentItem.optional" #optional name="optional" id="optional">
      <option [ngValue]="true">
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="weight" class="legend">Weight (%) <span class="requiredfield">*</span></label>
    <input class="text-field" required type="number" id="weight" max="100" name="weight"
      [(ngModel)]="this.assessmentItem.weight" #weight>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="quizAssessment" class="legend">Lesson Quiz</label>
    <select class="text-field" [(ngModel)]="this.assessmentItem.quizAssessment" #quizAssessment name="quizAssessment" id="quizAssessment">
      <option [ngValue]="false">
        No
      </option>
      <option [ngValue]="true">
        Yes
      </option>
    </select>
    <p class="form-info-p">Assessment will be taken before proceeding to next lesson
    </p>
  </div>
    </div>
  </section>

  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-clipboard-list" aria-hidden="true"></i>
      <span>{{isEdit ? 'Update this assessment\'s setup. Its questions are managed separately.' : 'After saving, you will be taken to the assessment so you can add its questions.'}}</span>
    </span>
    <span class="cf-footer__actions">
      <button type="button" class="btn btn--warning m-0" *ngIf="isEdit" routerLink="/user/assessmentdetails"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID,aid:this.assessmentItem.id}">Cancel</button>
      <button type="button" class="btn btn--warning m-0" routerLink="/user/assessmentconsole"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID}" *ngIf="!isEdit">Cancel</button>
      <!-- The two Save buttons here were identical apart from their *ngIf, and both carried
           id="crt-new-asmt" — a duplicate id in the document, which a jQuery handler binds to. -->
      <button type="submit" class="btn m-0" [disabled]="!newA.valid || freezePage_formSubmissionInProgress"
        id="crt-new-asmt">Save</button>
    </span>
  </div>
</form>
